<label for="mobileNumber" class="formInputLabel mb-1 block cursor-pointer" i18n="@@mobileNumberLabel">
  Mobile Number
</label>
<div class="flex items-center gap-2" dir="ltr">
  <select
    [(ngModel)]="selectedCountry"
    (change)="onCountryChange()"
    class="w-[100px] cursor-pointer rounded-[10px] border-2 bg-gray-100 px-3 py-3 focus:outline-none"
    [class.border-gray-400]="!error()"
    [class.border-red-500]="error()">
    <option *ngFor="let country of countries" [ngValue]="country">{{ country.flag }} {{ country.dialCode }}</option>
  </select>

  <input
    id="mobileNumber"
    type="tel"
    [value]="numberValue"
    (input)="onInputChange($event)"
    (blur)="onTouched()"
    class="w-full rounded-[10px] border-2 p-2 py-3 focus:outline-none"
    [class.border-gray-400]="!error()"
    [class.border-red-500]="error()"
    dir="ltr"
    placeholder="1234567891" />
</div>
